import { LayoutType, withLayout } from 'hocs/with-layout';
import { VaultDetailGuest } from './vault-detail-guest';

const WrappedVaultDetailGuest = withLayout(
  LayoutType.WithOldNavAndFooter,
  VaultDetailGuest,
);

export { WrappedVaultDetailGuest as VaultDetailGuest };
